/**
 * Brand logo: infinity-f mark with teal progress arc.
 *
 * Usage:
 *   <Logo />                       // logo only
 *   <Logo withWordmark />          // logo + "FullPracticeTests"
 *   <Logo size={40} />             // custom pixel height
 */
"use client";

import Image from "next/image";

interface LogoProps {
  /** Pixel height of the logo image. Defaults to 32. */
  size?: number;
  /** Whether to render the "FullPracticeTests" wordmark next to the mark. */
  withWordmark?: boolean;
  /** Extra class for the outer span. */
  className?: string;
  /** Wordmark size class (when withWordmark is true). */
  wordmarkClass?: string;
}

export function Logo({
  size = 32,
  withWordmark = false,
  className = "",
  wordmarkClass = "text-[15px] font-bold tracking-tight",
}: LogoProps) {
  // logo-mark.png is 345×257 — preserve aspect ratio
  const width = Math.round(size * (345 / 257));

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <Image
        src="/logo-mark.png"
        alt="FullPracticeTests logo"
        width={width}
        height={size}
        priority
      />
      {withWordmark && (
        <span className={wordmarkClass}>
          FullPracticeTests
        </span>
      )}
    </span>
  );
}
